<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">{{ title }}</h3>
                    <div class="box-tools pull-right">

                        <button
                            class="btn btn-box-tool"
                            :title="$t('collapse')"
                            type="button"
                            @click="isCollapse = !isCollapse"
                        >
                            <i
                                class="fa"
                                :class="{
                                    'fa-plus': !isCollapse,
                                    'fa-minus': isCollapse,
                                }"
                            />
                        </button>
                    </div>
                </div>

                <div
                    v-if="!isLoaded"
                    class="box-body with-border clearfix"
                >
                    <img
                        class="table-row-preloader"
                        rel="preload"
                        src="/img/table-row-preloader.gif"
                    />
                </div>

                <vue-slide-up-down v-else :active="isCollapse">
                    <div
                        v-if="isLoaded && !stats.length"
                        class="box-body with-border clearfix"
                    >
                        <p>
                            {{ $t('batchContactsList.empty') }}
                        </p>
                    </div>

                    <table
                        v-else
                        class="table table-striped table-hover"
                    >
                        <tbody>
                        <tr>
                            <th>{{ $t('id') }}</th>

                            <th>{{ $t('name') }}</th>

                            <th>{{ $t('batchContactsList.contacts') }}</th>
                        </tr>

                        <tr
                            v-for="stat in stats"
                            :key="stat.id"
                        >
                            <td>{{ stat.id }}</td>

                            <td>
                                {{ stat.name }}
                            </td>

                            <td>
                                <BadgeTotal
                                    :value="stat.totalCount"
                                    color="gray"
                                    :title="$t('batchContactsList.totalContacts')"
                                />

                                <BadgeTotal
                                    :value="stat.readyCount"
                                    color="green"
                                    :title="$t('batchContactsList.readyContacts')"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </vue-slide-up-down>
            </div>
        </div>
    </div>
</template>

<script>
import BadgeTotal from '@/components/subcomponents/BadgeTotal';
export default {
    name: "ListBatchContactsStats",
    components: {
        BadgeTotal,
    },
    props: {
        stats: {
            type: Array,
            default: () => [],
        },
        isLoaded: Boolean,
        title: String,
    },
    data() {
        return {
            isCollapse: true,
        };
    },
}
</script>
